import {CreateDarkTheme, CreateLightTheme, DualVariantTheme} from "../../Utils/CreateTheme";

const RobinTheme: DualVariantTheme = {
  name: 'Robin',
  darkTheme: CreateDarkTheme({
    palette: {
      type: 'dark',
      primary: {
        main: '#5e35b1',
      },
      secondary: {
        main: '#ff8a80',
      },
      text: {
        primary: 'rgb(194,188,184)',
        secondary: 'rgb(155,149,147)',
      },
      background: {
        default: 'rgb(29,30,34)',
        paper: 'rgb(44,47,52)',
      },
    },
  }),
  lightTheme: CreateLightTheme({
    palette: {
      type: 'light',
      background: {
        default: '#f0f2f5',
      },
      primary: {
        main: '#442681',
      },
      secondary: {
        main: '#cb6f61',
      },
      text: {
        primary: 'rgb(72,72,72)',
        secondary: 'rgb(118,118,118)',
      },
    },
  }),
};

export default RobinTheme;
